"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryUserPrivacyConsent = exports.DoubleOptInType = exports.UserIdentificationMethod = exports.UserIdentifierType = exports.ConsentCategory = exports.ConsentAction = exports.GlobalConsentType = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../date");
exports.NAMESPACE = 'Culligan.User.Privacy';
exports.GlobalConsentType = effect_1.Schema.Enums({
    /** Consent to track the User hydration */
    HydrationTracking: 'hydrationTracking',
    /** Consent to send general marketing comms */
    MarketingComms: 'marketingComms',
}).annotations({
    identifier: `${exports.NAMESPACE}.GlobalConsentType`,
    description: 'Global consents apply to all services and applications in the Culligan IoT ecosystem',
});
exports.ConsentAction = effect_1.Schema.Enums({ Accept: 'accept', Reject: 'reject' }).annotations({
    identifier: `${exports.NAMESPACE}.ConsentAction`,
    description: 'Accept or reject a consent to the processing of personal data',
});
exports.ConsentCategory = effect_1.Schema.Enums({
    Global: 'global',
    Loyalty: 'loyalty',
}).annotations({
    identifier: `${exports.NAMESPACE}.ConsentCategory`,
    description: 'Category of the consent',
});
exports.UserIdentifierType = effect_1.Schema.Enums({
    UserId: 'userId',
    Email: 'email',
}).annotations({
    identifier: `${exports.NAMESPACE}.UserIdentifierType`,
    description: 'The type of identifier used to infer the identify the User',
});
exports.UserIdentificationMethod = effect_1.Schema.Enums({
    AuthToken: 'authToken',
    Cookies: 'cookies',
    DoubleOptIn: 'doubleOptIn',
}).annotations({
    identifier: `${exports.NAMESPACE}.UserIdentificationMethod`,
    description: 'The method used to identify the User',
});
exports.DoubleOptInType = effect_1.Schema.Enums({
    /** User opened an identification link sent to their e-mail address */
    EmailLink: 'emailLink',
}).annotations({
    identifier: `${exports.NAMESPACE}.DoubleOptInType`,
    description: 'The type of double opt-in used to confirm the User identity',
});
exports.HistoryUserPrivacyConsent = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: 'Unique identifier (ID)' }),
    action: exports.ConsentAction,
    category: exports.ConsentCategory,
    type: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'The type of the consent' }),
    identifierType: exports.UserIdentifierType,
    identifier: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'The value of the User identifier',
    }),
    identificationMethod: exports.UserIdentificationMethod,
    doubleOptInType: effect_1.Schema.optionalWith(exports.DoubleOptInType, { exact: true, nullable: true }),
    setAt: effect_1.Schema.propertySignature(date_1.ValidDateFromIso8601String).annotations({
        description: 'The date when the consent was set',
    }),
    expiresAt: effect_1.Schema.optionalWith(date_1.ValidDateFromIso8601String, {
        exact: true,
        nullable: true,
    }).annotations({
        description: 'The date when the consent expires, if applicable',
    }),
    source: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Source of the consent action (application name, CRM, ...)',
    }),
    terms: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'A reference to the version of the terms presented to the User, or a verbatim copy',
    }),
    prompt: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: 'The text of the prompt presented to the User',
    }),
    proofOfConsent: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }).annotations({
        description: "A reference to a proof of the User's consent, if applicable",
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.HistoryUserPrivacyConsent`,
    description: 'An immutable historical record of the User privacy consents and revocations',
});
//# sourceMappingURL=privacy.js.map